import { GUIDE_EMBED_URL } from './config';

/**
 * Argomenti del Centro Aiuto pertinenti a Giotto. Allowlist chiusa: uno slug
 * inesistente non ricade su un fallback lato sito ma mostra una 404 dentro il
 * pannello.
 */
export const GUIDE_TOPIC_SLUGS = [
  'abbonamento',
  'account-e-setup',
  'giotto',
  'giotto-ai',
  'progetti-standard-giotto',
  'strumenti-editor-giotto',
];

/**
 * Prima parte del path -> argomento. Le rotte sono quelle dichiarate in
 * src/router/index.js.
 */
export const PATH_TO_GUIDE_TOPIC = {
  '': 'giotto',
  canvas: 'strumenti-editor-giotto',
  credits: 'giotto-ai',
  'how-to': 'giotto',
  projects: 'progetti-standard-giotto',
  start: 'giotto',
  subscription: 'abbonamento',
  'template-manager': 'strumenti-editor-giotto',
};

export const isGuideTopicSlug = (value) =>
  typeof value === 'string' && GUIDE_TOPIC_SLUGS.indexOf(value) !== -1;

export const getGuideTopicForPath = (pathname) => {
  if (typeof pathname !== 'string') return undefined;

  const segment = pathname.replace(/^\//, '').split('/')[0];
  return PATH_TO_GUIDE_TOPIC[segment];
};

/**
 * URL embed dell'argomento richiesto; senza argomento valido si apre la home
 * del Centro Aiuto.
 */
export const buildGuideEmbedUrl = (topicSlug) => {
  if (!isGuideTopicSlug(topicSlug)) return GUIDE_EMBED_URL;

  try {
    const url = new URL(GUIDE_EMBED_URL);
    url.pathname = `/aiuto/argomenti/${topicSlug}/embed`;
    return url.toString();
  } catch (error) {
    return GUIDE_EMBED_URL;
  }
};

/** Argomento corrente ricavato dall'URL mostrato nel pannello. */
export const getTopicSlugFromEmbedUrl = (embedUrl) => {
  try {
    const match = new URL(embedUrl).pathname.match(
      /^\/aiuto\/argomenti\/([^/]+)\/embed\/?$/
    );
    return match && isGuideTopicSlug(match[1]) ? match[1] : undefined;
  } catch (error) {
    return undefined;
  }
};
